import React, { useContext } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';

import DataHealthIcon from 'app/components/shared/icons/data-health';
import useUserData from 'hooks/useUserData';
import { postBestOfYearsPersistWinners } from 'services/best-of-years';
import { setIsFeedbackDrawerOpen, setIsUserDropdownOpen } from 'store/reducers/navbar-reducer';
import { addToast } from 'store/reducers/toast-reducer';
import { ThemeContext } from 'styled-components';

import {
  ChartIcon,
  InfoIcon,
  MessageIcon,
  PlayCircleIcon,
  QuestionIcon,
  Sparkle,
} from '../shared/icons';
import PersonIcon from '../shared/icons/person-icon';
import { NavButton } from './styled';

export default function MenuButtons() {
  const { push } = useHistory();
  const user = useUserData();
  const dispatch = useDispatch();
  const theme = useContext(ThemeContext);
  const financialReportAccess = user.permissions?.financial_report_access;
  const personIsFromKyu = user.kyu_company?.slug === 'kyu';

  const buttonsData = [
    {
      Icon: <PersonIcon />,
      title: 'Profile',
      show: true,
      onClick: () => {
        push({ pathname: `/my-profile`, state: { scrollToTop: true } });
      },
    },
    {
      Icon: <InfoIcon />,
      title: 'Privacy policy',
      show: true,
      onClick: () => window.open('https://kyu.com/legal/employee-privacy-notice', '_blank'),
    },

    {
      Icon: <InfoIcon />,
      title: 'Calculate winners',
      show: user.permissions?.best_of_year_admin === true,
      onClick: () => {
        postBestOfYearsPersistWinners(2025)
          .then(() => {
            dispatch(
              addToast({
                message: <span>Winners calculated successfully</span>,
                type: 'success',
              })
            );
          })
          .catch(() => {
            dispatch(
              addToast({
                message: 'Error calculating winners',
                type: 'error',
              })
            );
          });
      },
    },

    {
      Icon: <DataHealthIcon />,
      title: 'Data Health',
      show: user.permissions?.collective_data_health_access ? true : false,
      onClick: () => {
        push({
          pathname: `/resources/${user.permissions?.collective_data_health_access}/embed`,
          state: { scrollToTop: true },
        });
      },
    },
    {
      Icon: <Sparkle />,
      title: 'Creative Intelligence Report',
      show: user.permissions?.creative_intelligence_report_access ? true : false,
      onClick: () => {
        push({
          pathname: `/resources/creative-intelligence-report/embed`,
          state: { scrollToTop: true },
        });
      },
    },
    {
      Icon: <ChartIcon />,
      title: 'BD Pipeline',
      show: !!financialReportAccess,
      onClick: () => {
        push({
          pathname: `/dashboards/bd-pipeline`,
          state: { scrollToTop: true },
        });
      },
    },
    {
      Icon: <ChartIcon />,
      title: 'Group P&L',
      show: !!financialReportAccess && !!personIsFromKyu,
      onClick: () => {
        push({
          pathname: `/dashboards/group-pnl`,
          state: { scrollToTop: true },
        });
      },
    },
    {
      Icon: <ChartIcon />,
      title: 'Working Capital',
      show: !!financialReportAccess && !!personIsFromKyu,
      onClick: () => {
        push({
          pathname: `/dashboards/working-capital`,
          state: { scrollToTop: true },
        });
      },
    },
    {
      Icon: <MessageIcon />,
      title: 'Feedback',
      show: true,
      onClick: () => {
        dispatch(setIsFeedbackDrawerOpen(true));
      },
    },
    {
      Icon: <QuestionIcon />,
      title: 'FAQ',
      show: true,
      onClick: () => {
        push({ pathname: `/kyu-101`, hash: 'faq' });
      },
    },
    {
      Icon: <PlayCircleIcon />,
      title: 'kyu 101',
      show: true,
      onClick: () => {
        push({ pathname: `/resources/kyu-storybook` });
      },
    },
  ];

  return (
    <>
      {buttonsData
        .filter(({ show }) => show)
        .map(({ title, Icon, onClick }) => (
          <NavButton
            key={title}
            onClick={() => {
              onClick();
              dispatch(setIsUserDropdownOpen(false));
            }}
          >
            {React.cloneElement(Icon, { width: 16, height: 16, fill: theme.navBarIconColor })}
            <span>{title}</span>
          </NavButton>
        ))}
    </>
  );
}
